export enum MessageActionTypes {
    SET_MESSAGES = "SET_MESSAGES",
    CLEAR_MESSAGES = "CLEAR_MESSAGES"
}